import Documents, { IDocument, IDocumentApiModel } from './Document.model';

export interface IStudioDocuments {
  id: number;
  favorite: boolean;
  documentId: string;
  studioId: string;
  document: IDocument;
}

export interface IStudioDocumentsApiModel {
  id: number;
  favorite: boolean;
  documentId: string;
  studioId: string;
  document: IDocumentApiModel;
}

export default class StudioDocuments implements IStudioDocuments {
  public readonly id: number;

  public readonly favorite: boolean;

  public readonly studioId: string;

  public readonly documentId: string;

  public readonly document: IDocument;

  constructor(
    id: number,
    documentId: string,
    document: IDocument,
    favorite: boolean,
    studioId: string,
  ) {
    this.id = id;
    this.documentId = documentId;
    this.document = document;
    this.favorite = favorite;
    this.studioId = studioId;
  }

  static fromApiModel(apiModel: IStudioDocumentsApiModel) {
    const { id, documentId, favorite, studioId } = apiModel;

    const document = Documents.fromApiModel(apiModel.document);
    return new StudioDocuments(id, documentId, document, favorite, studioId);
  }

  static arrayFromApiModel(arrayApiModel: IStudioDocumentsApiModel[]) {
    const array = arrayApiModel.map(apiModel => {
      return this.fromApiModel(apiModel);
    });

    return array;
  }
}
